import styled from 'styled-components';

export const Container = styled.div<{ showing: boolean }>`
  background: ${props => (props.showing ? props.theme.colors.background.secondary : 'transparent')};
  bottom: 0;
  overflow-y: scroll;
  padding: 20px;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 10000;

  ${props =>
    !props.showing &&
    `
    background: 'transparent';
    bottom: initial;
    display: flex;
    flex-flow: column;

    > * {
      margin-bottom: 16px;
    }
`}
`;

export const Controls = styled.div`
  display: flex;
  flex-flow: column;

  > * {
    margin-bottom: 16px;
  }
`;

export const Additional = styled.details`
  cursor: pointer;
  max-width: 180px;

  > * {
    margin: 8px 0;
  }
`;

export const Summary = styled.summary`
  font-family: ${props => props.theme.fontFamilies.main.regular};
`;

export const InfoSection = styled.div`
  background: ${props => props.theme.colors.background.primary};
  border: 1px solid ${props => props.theme.colors.background.tertiary};
  border-radius: 4px;
  margin-bottom: 16px;
  padding: 12px;
`;

export const InfoSectionTitle = styled.h4`
  font-family: ${props => props.theme.fontFamilies.main.medium};
  font-size: 11px;
  letter-spacing: 0.5px;
  margin: 0 0 8px;
  text-transform: uppercase;
`;

export const InfoRow = styled.div`
  display: flex;
  flex-flow: row wrap;
  gap: 4px;
  margin-bottom: 6px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const InfoLabel = styled.span`
  color: ${props => props.theme.colors.content.secondary};
  flex-shrink: 0;
  font-family: ${props => props.theme.fontFamilies.main.regular};
  font-size: 11px;
`;

export const InfoValue = styled.span`
  font-family: ${props => props.theme.fontFamilies.main.medium};
  font-size: 11px;
  word-break: break-all;
`;

export const ApplySuccessHint = styled.span`
  color: rgb(42, 120, 75);
  display: block;
  font-family: ${props => props.theme.fontFamilies.main.medium};
  font-size: 11px;
  margin-top: ${props => `${props.theme.space?.[2] ?? 8}px`};
`;
